<aside class="dialog" fxLayout="column">
  @if (dialogTitle.length) {
    <mat-toolbar [color]="color">
      <h2 class="dialog__title">
        <ng-content select="[qtDialogTitle]"></ng-content>
      </h2>
      <span fxFlex></span>
      @if (!disableClose) {
        <button mat-icon-button matDialogClose color="primary">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-toolbar>
  }
  @if (dialogContent.length) {
    <mat-dialog-content #contentDiv [ngClass]="contentClass">
      <ng-content select="[qtDialogContent]"></ng-content>
    </mat-dialog-content>
  }
  @if (dialogActions.length) {
    <mat-dialog-actions fxLayout fxLayoutAlign="end">
      <ng-content select="[qtDialogActions]"></ng-content>
    </mat-dialog-actions>
  }
</aside>
